import React from 'react';
import Page from './page';

function ToolsPolicy() {
    return (
        <Page label="326 Tools — Legal" title="Privacy Policy">
            <div className="doc">
                <p>Privacy policy coming soon.</p>
            </div>
        </Page>
    );
}

export default ToolsPolicy;
